import { changeCustomerFulfillmentMethodStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector";
import { css } from "styled-components";

Object.assign(changeCustomerFulfillmentMethodStyles, {
    ...changeCustomerFulfillmentMethodStyles,
    container: {
        offsetCss: css`
            margin: 0;
        `,
    },
    radioGroupGridItem: {
        width: 12,
        css: css`
            padding: 0 15px;
        `,
    },
    pickupLocationGridItem: {
        width: 12,
        css: css`
            padding: 0 15px;
        `,
    },
});
